"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavIcon = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _styledTools = require("styled-tools");

var _Icons = require("../Icons");
/* eslint-disable import/no-cycle */


var NavIcon = _stylitas.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

exports.NavIcon = NavIcon;
NavIcon.Right = (0, _stylitas.styled)(_Icons.ArrowRight)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
NavIcon.Down = (0, _stylitas.styled)(_Icons.ArrowDown)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  display: ", ";\n\n  ", "\n"])), (0, _styledTools.theme)('colorBrandPrimaryDefault'), (0, _styledTools.ifProp)('open', 'block', 'none'), _styleUtilities.media.md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n  "]))));